export default "__VITE_ASSET__C4uSSl7v__"